import styles from './pill.module.scss';

interface OwnProps {
    name: string;
    onDeleteClick: () => void;
    disabled?: boolean;
}

export function Pill(props: OwnProps) {
    return (
        <div className={styles.pill}>
            <span>{props.name}</span>
            <button disabled={props.disabled} onClick={props.onDeleteClick}>
                <i className="fa-light fa-close" />
            </button>
        </div>
    );
}
